// MARK: Mobx
import { observable, action, computed } from "mobx";

// MARK: Api
import * as api from "@startapp/mistral-admin-api";

// MARK: Resources
import VariableChangeHandler from "../../resources/VariableChangeHandler";
export default class LanguageStore extends VariableChangeHandler {
	private languageKey = "CURRENT_LANGUAGE_SELECTED";

	@observable public selectedLanguages: api.Language = api.Language.ptBr;

	@computed
	public get selectedLanguage() {
		const currentLanguage = localStorage.getItem(this.languageKey);

		if (currentLanguage) {
			return currentLanguage as api.Language;
		}
		return api.Language.ptBr;
	}

	@action
	public changeLanguage = (language: api.Language) => {
		localStorage.setItem(this.languageKey, language);
		window.location.reload();
	};
}
